module.exports = __webpack_public_path__ + "static/img/icon-10.41cd6d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/icon-10.png
// module id = Vz+P
// module chunks = 1